/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createProd } from '../../factoriesAny.js';
export var prodDependencies = {
  multiplyDependencies: multiplyDependencies,
  typedDependencies: typedDependencies,
  createProd: createProd
};